import create from "zustand";
import { persist } from "zustand/middleware";

const emptyWorkExperience = {
  title: '',
  jobRole: '',
  startDate: '',
  endDate: '',
  currentlyOngoing: false,
  summaryPoints: [''],
  projectLink: '',
};

const emptyEducation = {
  schoolName: '',
  schoolLocation: '',
  degree: '',
  graduationMonth: '',
  graduationYear: '',
  fieldOfStudy: '',
};

export const defaults = {
  activeFormStep: 0,
  selectedTemplate: '',
  headings: {
    firstName: '',
    surname: '',
    profession: '',
    city: '',
    country: '',
    pinCode: '',
    phone: '',
    email: '',
    linkedin: '',
    github: '',
    portfolio: '',
    summary: '',
  },
  headerFlags: {
    linkedin: false,
    github: false,
    portfolio: false,
  },
  workExperiences: [],
  educations: [],
  skills: {
    skills: { enabled: true, items: [] },
    frameworks: { enabled: true, items: [] },
    tools: { enabled: true, items: [] },
    languages: { enabled: true, items: [] },
  },
};

const useResumeStore = create(persist((set, get) => ({
  ...defaults,
  setActiveFormStep: (activeFormStep) => set({ activeFormStep }),
  setSelectedTemplate: (selectedTemplate) => set({ selectedTemplate }),
  setHeadings: (headings) => set((state) => ({
    headings: { ...state.headings, ...headings },
  })),
  setHeaderFlags: (headerFlags) => set((state) => ({
    headerFlags: { ...state.headerFlags, ...headerFlags },
  })),

  // Work Experience
  addWorkExperience: () => set((state) => ({
    workExperiences: [...state.workExperiences, { ...emptyWorkExperience }],
  })),
  updateWorkExperience: (index, data) => set((state) => {
    const updated = [...state.workExperiences];
    updated[index] = { ...updated[index], ...data };
    return { workExperiences: updated };
  }),
  removeWorkExperience: (index) => set((state) => ({
    workExperiences: state.workExperiences.filter((_, i) => i !== index),
  })),

  // Education
  addEducation: () => set((state) => ({
    educations: [...state.educations, { ...emptyEducation }],
  })),
  updateEducation: (index, data) => set((state) => {
    const updated = [...state.educations];
    updated[index] = { ...updated[index], ...data };
    return { educations: updated };
  }),
  removeEducation: (index) => set((state) => ({
    educations: state.educations.filter((_, i) => i !== index),
  })),

  addSkillItem: (category, item) => set((state) => ({
    skills: {
      ...state.skills,
      [category]: {
        ...state.skills[category],
        items: [...state.skills[category].items, item],
      },
    },
  })),
  removeSkillItem: (category, index) => set((state) => ({
    skills: {
      ...state.skills,
      [category]: {
        ...state.skills[category],
        items: state.skills[category].items.filter((_, i) => i !== index),
      },
    },
  })),
  reset: () => {
    set(defaults);
    localStorage.removeItem('resume-draft');
  },
}), {
  name: 'resume-draft',
  partialize: (state) => ({
    selectedTemplate: state.selectedTemplate,
    headings: state.headings,
    headerFlags: state.headerFlags,
    workExperiences: state.workExperiences,
    educations: state.educations,
    skills: state.skills,
  }),
}));

export default useResumeStore;
